module.exports = __webpack_public_path__ + "img/detailss.823b7978.png";